const base = () =>
  String(process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
export async function agreementResponse(path, token) {
  const response = await fetch(`${base()}/agreements${path}`, {
    headers: { Authorization: `Bearer ${token}` },
    cache: "no-store",
  });
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw Error(body?.error?.message || "Could not download agreement");
  }
  return response;
}
export async function downloadAgreement(path, name, token) {
  let handle;
  if (window.showSaveFilePicker) {
    try {
      handle = await window.showSaveFilePicker({ suggestedName: name });
    } catch (error) {
      if (error.name === "AbortError") return;
      throw error;
    }
  }
  const response = await agreementResponse(path, token);
  if (handle && response.body) {
    const writable = await handle.createWritable();
    try {
      await response.body.pipeTo(writable);
    } catch (error) {
      await writable.abort().catch(() => {});
      throw error;
    }
    return;
  }
  const blob = await response.blob(),
    url = URL.createObjectURL(blob),
    anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = name;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}
